import Error from "./errorType1";

export { Error };
export default Error;
